export const footerKeys = {
  brandTitle: "footer:brand:title",
  tagline: "footer:tagline",
  servicesTitle: "footer:columns:services:title",
  helpTitle: "footer:columns:help:title",
  reachTitle: "footer:columns:reach:title",
  getDirections: "footer:getDirections",
  copyright: "footer:copyright",
} as const;

export const footerData = {
  services: [
    { key: "services:flags", to: "/services/custom-flags" },
    { key: "services:flagpoles", to: "/services/flagpoles" },
    { key: "services:banners", to: "/services/banners" },
    { key: "services:badges", to: "/services/badges" },
    { key: "services:sticker", to: "/services/sticker" },
    { key: "services:apparel", to: "/services/apparel" },
    { key: "services:lanyards", to: "/services/lanyards" },
  ],
  help: [
    { key: "footer:help:faqs", to: "/services/custom-flags#faq" },
    { key: "nav:contact", to: "/contact" },
  ],
  reach: {
    address: "contact:data:address",
    mapUrl: "contact:data:mapUrl",
    mapEmbedSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19184.54179795198!2d54.50653217114744!3d24.35377587023259!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e412a72b896bf%3A0xd8e8d66893188fa5!2sCreation%20Arts%20For%20Flags%20and%20Digital%20Printing%20LLC!5e0!3m2!1sen!2sus!4v1758530055895!5m2!1sen!2sus",
    email: ["connect@creationarts.com"],
    mobile: ["+971 55 407 1164", "+971 55 407 1163", "+971 52 268 5538"],
    telephone: ["+971 2 449 2990"],
    whatsappPhone: "+971 55 407 1164",
    socials: {
      instagram: "https://www.instagram.com/creationartsuae/?hl=en",
      whatsapp: "https://api.whatsapp.com/send?phone=971554071164",
    },
  },
  hours: [
    { day: "footer:days:monThu", open: "10:00", close: "19:00" },
    { day: "footer:days:fri", open: "16:00", close: "19:00" },
    { day: "footer:days:sat", open: "11:00", close: "17:00" },
  ],
};
